ACDiscountApp.CartPage.Show_CalculateTier = function () {
    let TierProducts = [];
    var postDataDiscountArrayObject = [];
    var discountMsg = "TIERED_DISCOUNT";
    let callProductDiscountFunction = true;
    let callCartAttributeDiscountFunction = true
    // Utility function to create a discount object, used in all three discount types.
    function createDiscountObject(msg, variantId, value) {
      return {
        message: msg,
        targets: [{ productVariant: { id: variantId } }],
        value: value,
      };
    }
  
    // Creates a percentage discount object as per Shopify requirements.
    function createPercentageDiscountObject(msg, percentage, variantId) {
      return createDiscountObject(msg, variantId, {
        percentage: { value: percentage },
      });
    }
  
    // Creates a fixed amount discount object and calculates the total discount amount.
    function createAmountOffDiscountObject(
      msg,
      variantId,
      amount,
      qtys
    ) {
      const totalDiscountedAmount = (amount * qtys).toFixed(2);
      return createDiscountObject(msg, variantId, {
        fixedAmount: { amount: totalDiscountedAmount },
      });
    }
  
    // Creates a discounted price object and calculates the discount based on the original price.
    function createDiscountedPriceDiscountObject(
      msg,
      variantId,
      amount,
      qtys,
      price
    ) {
      const discountAmount = (amount).toFixed(2);
      if (price > discountAmount) {
        const discountValue = (price - discountAmount).toFixed(2);
        const totalDiscountedAmount = (discountValue * qtys).toFixed(2);
  
        return createDiscountObject(msg, variantId, {
          fixedAmount: { amount: totalDiscountedAmount },
        });
      }
  
      // Return null or a default value if no discount applies (optional based on your use case)
      return null;
    }
  
    async function setDateTimeInCart() {
      let cartAttribute = callCartAttributeDiscountFunction ? JSON.stringify(postDataDiscountArrayObject) : `${globalFields.Storetime()},${Shopify.shop}`
      try {
        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            attributes: {
              Discountly_dateTime: cartAttribute,
            },
          }),
        });
  
        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }
  
        const data = await response.json();
         jQuery(".loading-overlay").addClass("hidden");
        await fetch("/cart.js").then((r) =>
          r.json().then((data) => ({ status: r.status, body: data }))
        );
      } catch (error) {
        // console.error('Failed to update cart:', error);
      }
    }
  
  
  
  
      // Item and line Item Price Selector;
       var cartPageItemPrice = '.js-contents .cart__price-wrapper';
       var cartPageLineItemPrice = '.js-contents .cart-totals.tr.hide-sm';
    
       var drawerItemPrice = '.previewCart .previewCartItem-price .price';
       var drawerLineItemPrice = '.drawer__contents .cart-item .cart-item__totals';
      
        // Cart Total Selector Drawer and cart page;
       var cartPageCartTotalPrice = '.cartTotal .cart_total';
       var cartPageCartTotalPrice_two = '.cart-container .cart-total.cart-total-subtotal .cart-total-value';
  
       var drawerCartTotalPrice = '.drawer__footer .cart_total';
       var drawerCartTotalPrice_two = '.previewCartTotals.total  .previewCartTotals-value';
    
       // Saving Message 
       var savingMessageCartPage = '.cartTotal .totalSave';
        // CheckOut Button;
       var checkoutButtonCartPage = '.cart__footer button[name="checkout"]';
       var checkoutButtonDrawerPage = '.drawer__footer button[name="checkout"]';
       
    
    
  
  let currency = globalFields.currency.toLowerCase();
  let formatMoney = (amount) => `<span class="money" data-currency-${currency}="${globalFields.currencySymbol + amount}" data-currency="${globalFields.currency}">${globalFields.formatMoney(amount, globalFields.amount)}</span>`;
  
    var UpdateCartItem = function (item, updatedItemPrice, updatedLinePrice, isNotInRange, isUpdate, index) {//Show the updated discounted price and original price
     jQuery('.js-contents .discounts.list-unstyled').hide();
     jQuery('.cart-item__details .discounts').hide();
    // return
      if (!isUpdate) return;
      let findSelector = jQuery(cartPageItemPrice).eq(index).find('.cart-item__discounted-prices').length || jQuery(drawerItemPrice).eq(index).find('.cart-item__discounted-prices').length? '.cart-item__discounted-prices' : '.product-option:first';

       let item_original_price = globalFieldsCartPage_AC.cartTiersArray[index].compare_at_price > 0 
                        ? globalFieldsCartPage_AC.cartTiersArray[index].compare_at_price
                        : item.original_price; 
        let item_original_line_price = item_original_price * item.quantity;

     
      
     let [originalItemPrice, originalLinePrice] = [item_original_price,item_original_line_price].map(price => globalFields.ConvertToFixedDecimalString(price / 100));
          [updatedItemPrice, updatedLinePrice] = [updatedItemPrice, updatedLinePrice].map(globalFields.ConvertToFixedDecimalString);
    
      let condition1 = updatedItemPrice >= parseFloat(originalItemPrice);

     let compare_at_price = globalFieldsCartPage_AC.cartTiersArray[index].compare_at_price > 0 ;
      if (compare_at_price) {
        condition1 = false;
        isNotInRange = false;
      }
      
      const itemOriginalPrice =  isNotInRange || condition1 ?  `${formatMoney(updatedItemPrice)}` :`<span><s >${formatMoney(originalItemPrice)}</s></br><span style="font-weight: var(--font-weight-semibold);line-height: var(--body-line-height);letter-spacing: var(--body-letter-spacing);color: var(--color-text);"> ${formatMoney(updatedItemPrice)}</span></span>`;
      const itemlinePriceHtml =  isNotInRange || condition1 ?  `${formatMoney(updatedLinePrice)}` :`<span><s >${formatMoney(originalLinePrice)}</s></br><span style="font-weight: var(--font-weight-semibold);line-height: var(--body-line-height);letter-spacing: var(--body-letter-spacing);color: var(--color-text);"> ${formatMoney(updatedLinePrice)}</span></span>`;
      //const itemlinePriceHtml = isNotInRange || condition1? `${formatMoney(updatedLinePrice)}`:`<span><s>${formatMoney(originalLinePrice)}</s> ${formatMoney(updatedLinePrice)}</span>`;
    //  const itemlinePriceHtml = isNotInRange || condition1? `${formatMoney(updatedLinePrice)}`:`<span style="font-weight: var(--font-weight-semibold);line-height: var(--body-line-height);letter-spacing: var(--body-letter-spacing);color: var(--color-text);"> ${formatMoney(updatedLinePrice)}</span>`;
    
          jQuery(cartPageItemPrice).eq(index).html(itemOriginalPrice);//cart item price html
          jQuery(drawerItemPrice).eq(index).html(itemOriginalPrice);//drawer item price html
          jQuery(cartPageLineItemPrice).eq(index).html(itemlinePriceHtml);//cart LineItem Price  html
          jQuery(drawerLineItemPrice).eq(index).html(itemlinePriceHtml);//drawer LineItem Price  html
  };
  
  
    
    
  var UpdateCartSubtotal = function (isUpdate, updatedTotalPrice, originalTotalPrice) {
    
    if (isUpdate) {      
        updatedTotalPrice = globalFields.ConvertToFixedDecimalString(updatedTotalPrice), originalTotalPrice = globalFields.ConvertToFixedDecimalString(originalTotalPrice);
        if (originalTotalPrice != updatedTotalPrice) {
            jQuery(cartPageCartTotalPrice).html(`<span>SUBTOTAL</span> <span>${globalFields.formatMoney(updatedTotalPrice, globalFields.amount)} ${globalFields.currency}</span>`);
            jQuery(cartPageCartTotalPrice_two).html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalTotalPrice, globalFields.amount) + '</span>');
            jQuery(drawerCartTotalPrice_two).html(' <span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
            jQuery(drawerCartTotalPrice).html(`<span>SUBTOTAL</span> <span>${globalFields.formatMoney(updatedTotalPrice, globalFields.amount)} ${globalFields.currency}</span>`);
           }
        else {
        jQuery(cartPageCartTotalPrice).html(`<span>SUBTOTAL</span> <span>${globalFields.formatMoney(updatedTotalPrice, globalFields.amount)} ${globalFields.currency}</span>`);
        jQuery(cartPageCartTotalPrice_two).html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
       jQuery(drawerCartTotalPrice_two).html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
        jQuery(drawerCartTotalPrice).html(`<span>SUBTOTAL</span> <span>${globalFields.formatMoney(updatedTotalPrice, globalFields.amount)} ${globalFields.currency}</span>`);
        }
         updateDiscount(originalTotalPrice,updatedTotalPrice)
    }
}
  

  var updateDiscount = function(originalTotalPrice,updatedTotalPrice){
// discount amount show start
const selectorDrawer = '.previewCartInfo .previewCartTotals.cart-total-savings';
const selectorCart = '.cart-totals .cart-discount.cart-total-savings';

const $drawer = $(selectorDrawer);
const $cart = $(selectorCart);

let discount = originalTotalPrice - updatedTotalPrice;

// Guard clause: don't show negative or zero discount
if (!discount || discount <= 0) {
  $drawer.remove();
  $cart.remove();
  return;
}

// Format properly once
discount = globalFields.ConvertToFixedDecimalString(discount);
const formattedDiscount = `-${globalFields.formatMoney(discount, globalFields.amount)}`;

const templateDrawer = `
  <div class="previewCartTotals-label"><span class="text">Discount:</span></div>
  <div class="previewCartTotals-value"><span class="text" data-saved-discount-value="">${formattedDiscount}</span></div>
`;

const templateCart = `
  <div class="cart-total-label"><span class="text">Discount:</span></div>
  <div class="cart-total-value"><span class="text" data-saved-discount-value="">${formattedDiscount}</span></div>
`;

// drawer update/insert
if ($drawer.length) {
  $drawer.css("display", "block");
  $drawer.html(templateDrawer);
} else {
  $('.previewCartInfo .previewCartTotals.subTotal').after(
    `<li class="previewCartTotals cart-total-savings" data-saved-discount-display="">${templateDrawer}</li>`
  );
}

// cart page update/insert
if ($cart.length) {
  //$cart.css("display", "block");
  $cart.html(templateCart);
} else {
  $('.cart-totals .cart-total.cart-total-grandtotal').before(
    `<li class="cart-discount cart-total-savings" data-saved-discount-display="">${templateCart}</li>`
  );
}
// discount amount show end
 }

    
      var UpdateSavingMessage = function (isUpdate) {//Show the Saving Message with discounted price
        debugger
        if (priceDiff > 0 && isUpdate && globalFields.isCartPage) {
            // var saveMessage = globalFields.settings.cart_saving_message.replace('{{discount_amount}}', `${formatMoney(priceDiff.toFixed(2))}`);
            var saveMessage = globalFields.settings.cart_saving_message.replace('{{discount_amount}}', ``);
            var saveHtml = '<span id="saved-banner">' + saveMessage + '</span>';
          let savingMessagePosition = jQuery(window).width() < 700 ? 'center': 'end';
          // jQuery('#saved-banner-div').length == 0 ? jQuery(savingMessageCartPage).html(`<div id="saved-banner-div" style="text-align: ${savingMessagePosition};" class="col-md-14">'<span id="saved-banner">${saveMessage}</span></div>`) : jQuery('#saved-banner-div').html(saveHtml);
              jQuery(savingMessageCartPage).html(`<span>${saveMessage}:</span><span>${formatMoney(priceDiff.toFixed(2))}</span>`);
        }
        else if (globalFields.isCartPage) {
            jQuery('#saved-banner-div').remove();
        }
    }
    
  
                  var CheckoutClickCart = function () {
                      $(document).on('click', checkoutButtonDrawerPage, function (e) {
                          TieredPricingCart(globalFieldsCartPage_AC.cartObj, false);
                          GetCode(false);
                      });
                  }
                  
                  var CheckoutClickAjax = function () {
                      $(document).on('click', checkoutButtonDrawerPage, function (e) {
                          e.preventDefault();
                          GetCode(true);
                      });
                  }
  
    
    
     var GetCode = function (isUpper) {
        if (priceDiff > 0 && !callProductDiscountFunction) {
            jQuery.ajax({
                type: "POST", async: false, url: "https://customerapp.anncode.com/tier/ACPGenerateDiscountCode",
                data: { priceDifference: priceDiff, subTotal: minimumDiscountSubtotal, variantIds: variantIdsToSend.toString() },
                success: function (result) {
                    var data_ = JSON.stringify(result); var parsed_data = JSON.parse(data_); var PRID = parsed_data.PRID;
                    var DCID = parsed_data.DCID; var DiscountCode = parsed_data.DiscountCode;
                    SetCookie("discountCodes", PRID + "-" + DCID + "-" + DiscountCode, 30);
                    if (!isUpper) {
                        DiscountCodeCookie(DiscountCode);
                        jQuery('form[action="/cart"]').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
                          window.location.href = '/checkout?discount=' + DiscountCode;
                    } else {
                        DiscountCodeCookie(DiscountCode);
                        //jQuery('form.cart-form').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
                        window.location.href = '/checkout?discount=' + DiscountCode;
                    }
                },
                error: function (e) { console.log(e.statusText); window.location.href = '/checkout'; }
            });
        }
        else if (isUpper) {
            window.location.href = '/checkout';
        }
      else{
        window.location.href = '/checkout';
      }
    }
    
     var ReInvokeAjaxCartButton = function () {
        jQuery('.mb_cart.mb_item button.btn, .top-header .dropdown-cart button.btn').off("click"); CheckoutClickAjax();
     }
    
    var variantIdsToSend = [], minimumDiscountSubtotal = 0, priceDiff = 0;
      var hide_buttons = null;
      var HideAdditionalPayments = function() {      
      hide_buttons = setInterval(function() {
        if(jQuery('.additional_checkout_buttons, .dynamic-checkout__content').length>0){
          jQuery('.additional_checkout_buttons, .dynamic-checkout__content').hide();
          clearInterval(hide_buttons);
        }
      }, 500);
    }
    
    var TieredPricingCart = function (cartObject, isUpdate) {
        variantIdsToSend = []; minimumDiscountSubtotal = 0; priceDiff = 0; var updatedTotalPrice = 0;TierProducts = [];postDataDiscountArrayObject = [];
        for (k = 0; k < cartObject.items.length; k++) {
            var item = cartObject.items[k], isInRange = true; itemTiers = GetTiersFromTiersArray(item.variant_id);

          // item.original_line_price
          if (itemTiers != undefined && itemTiers.status && globalFields.StartEndDateValid(itemTiers.start_date, itemTiers.end_date)) {
            
            let DiscountAppliedOn = itemTiers.DiscountAppliedON != null &&  itemTiers.DiscountAppliedON  != '' &&  itemTiers.DiscountAppliedON != undefined ? true : false;
            let Location_Tag_s = itemTiers.Location_Tag_ != null &&  itemTiers.Location_Tag_  != '' &&  itemTiers.Location_Tag_ != undefined ? true : false;
               if(DiscountAppliedOn){
                if(Location_Tag_s){
                   let DiscountAppliedOnTag =itemTiers.DiscountAppliedON == 'Both_Store' || itemTiers.DiscountAppliedON == 'Online_Store' ? true : false;
                   let LocationObject = Object.keys(itemTiers.Location_Tag_);
                   if(LocationObject[0] == 'StoreLocation'){
                    let StoreLocationcheck =  itemTiers.Location_Tag_[LocationObject[0]].includes(globalFields.Storecountry) || itemTiers.Location_Tag_[LocationObject[0]].includes(globalFields.Storecity) ? true : false;
                    if(StoreLocationcheck && DiscountAppliedOnTag){
                        var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                        updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                        if (rslt[1]) {
                        updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                        }
                      }else{
                      updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                      }
                   }else{
                   let TierLocation = itemTiers.Location_Tag_[LocationObject[0]];
                   let CusotmerCountryLocation = globalFields.Customercountry;
                   let CusotmerCityLocation = globalFields.Customercity;
                   let CustomerLocationcheck_1 = (arr, arr1) =>{return arr.some(item => arr1.includes(item))};
                   let CustomerLocationcheck_2 = (arr2, arr3) =>{return arr2.some(item => arr3.includes(item))};
                   let CityValue = CustomerLocationcheck_1(TierLocation,CusotmerCountryLocation);
                   let CountryValue = CustomerLocationcheck_2(TierLocation,CusotmerCityLocation);
                     if(DiscountAppliedOnTag && (CityValue || CountryValue)){
                        var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                        updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                        if (rslt[1]) {
                        updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                        }
                     }else{
                       updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                     }
                   }
                                                   
                 }else{
                  if(itemTiers.DiscountAppliedON == 'Both_Store' || itemTiers.DiscountAppliedON == 'Online_Store' ){
                   var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                  updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                  if (rslt[1]) {
                  updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                  }
                 }else{
                    updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                 }
                 }
                 
               }else{
                var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                if (rslt[1]) {
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                }
                 
               }

            
             }
            else {
                 UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), true, isUpdate, k);
     
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
            }
          
            if (!isInRange) {
                minimumDiscountSubtotal += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100); variantIdsToSend.push(item.variant_id);
            }
        }

          let subtotal = 0;
          
          // Add amount logic
          globalFieldsCartPage_AC.cartTiersArray.forEach((tier, index) => {
              const item = globalFieldsCartPage_AC.cartObj.items[index];
              if (tier.compare_at_price > 0) {
                  subtotal += tier.compare_at_price* item.quantity;
              } else {
                  
                  subtotal += item.original_price * item.quantity;
              }
          });
        

        originalTotalPrice =  subtotal/100

      
        UpdateCartSubtotal(isUpdate, globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice), globalFields.ConvertToFixedDecimalNumber(originalTotalPrice));
        priceDiff = globalFields.ConvertToFixedDecimalNumber((globalFields.ConvertToFixedDecimalNumber(originalTotalPrice) - globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice)));
        UpdateSavingMessage(isUpdate);
      if (callProductDiscountFunction) {setDateTimeInCart()}
      	if(priceDiff){
          HideAdditionalPayments();
        }
      	setTimeout(function(){
          clearInterval(hide_buttons);
        }, 5000);
    }
setTimeout(function(){
      clearInterval(hide_buttons);
    }, 10000);
    
    var GetTiersFromTiersArray = function (variantId) {
        var tierObj = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.variant_id === variantId); });
        if (tierObj[0].tiers == "[]") {
            return undefined;
        }
        else {
            return globalFields.GetTierObject(tierObj[0].tiers[0], variantId);
        }
    }

    var CalculateTier = function (item, itemTiers, updatedTotalPrice, isUpdate, isNotInRange, index) {
        const isFound = TierProducts.some(element => element.VarientID === item.variant_id);
        for (i = 0; i < itemTiers.tier_min.length; i++) {
            var allVariantItemQty = 0;
            var tierPrice = parseFloat(itemTiers.tier_values[i]);
            var minTier = parseInt(itemTiers.tier_min[i])
            const maxTier = itemTiers.tier_max[i] === 'max' || itemTiers.tier_max[i] === '' ? itemTiers.tier_max[i] : parseInt(itemTiers.tier_max[i]);
            discountMsg = itemTiers.discountCouponTitle || discountMsg;

            var updatedItemPrice = 0, updatedLinePrice = 0, condition1 = false, condition2 = false;

            if (itemTiers.entity_type === 'products' || itemTiers.entity_type === 'collections') {
                var tempItemArray = [];
                if (itemTiers.entity_type === 'collections') {
                    var tempTierArray = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.tiers != '[]' && n.tiers[0].entity_type == 'collections' && n.tiers[0].entity_id == itemTiers.entity_id); });
                    for (var m = 0; m < tempTierArray.length; m++) {
                        var temp = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.variant_id == tempTierArray[m].variant_id); });
                        if (temp.length != 0) {
                            tempItemArray.push(temp[0]);
                        }
                    }
                }
                else {
                    tempItemArray = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.product_id == item.product_id ); });
                }

                for (j = 0; j < tempItemArray.length; j++) { allVariantItemQty += tempItemArray[j].quantity; }
                condition1 = allVariantItemQty >= minTier;
                condition2 = maxTier == "max" || allVariantItemQty <= maxTier;
            }
            else {
                condition1 = item.quantity >= minTier;
                condition2 = maxTier == "max" || item.quantity <= maxTier;
            }

            if (condition1 && condition2) {
                        const Vid = `gid://shopify/ProductVariant/${item.variant_id}`;
                        const currencyRate = Number(Shopify.currency.rate);
                        const qtys = item.quantity;
                        const compare_at_price = globalFieldsCartPage_AC.cartTiersArray[index].compare_at_price > 0 
                        const item_original_price = globalFieldsCartPage_AC.cartTiersArray[index].compare_at_price > 0 
                        ? globalFieldsCartPage_AC.cartTiersArray[index].compare_at_price/100
                        : item.original_price/100
                        tierPrice = itemTiers.discount_type != 'percentage' ? tierPrice*currencyRate : tierPrice
                        isNotInRange = false;
                        let function_tierPrice = 0;
                        let postDataDiscountObject = {};
                        let tempTierProductsobj = {};


                if (itemTiers.discount_type == 'percentage') {
                  
                    var originalPriceCut = parseFloat(globalFields.ConvertToFixedDecimalNumber((parseFloat(tierPrice) / 100) * globalFields.ConvertToFixedDecimalNumber(item_original_price)));
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(item_original_price) - originalPriceCut);

                    if (compare_at_price) {
                     let discounted_price = item_original_price - (item.original_price / 100)
                     function_tierPrice = parseFloat(originalPriceCut) - discounted_price 
                     originalPriceCut = function_tierPrice < 0 ? 0 :  function_tierPrice
                  }
                  
                  if (!isFound) {
                        tempTierProductsobj = { Discountvalue: tierPrice, DiscountType: 'percentage', VarientID: item.variant_id };
                       // postDataDiscountObject = createPercentageDiscountObject(discountMsg, tierPrice, Vid);
                    
                               let resposne = createAmountOffDiscountObject(discountMsg, Vid, function_tierPrice, qtys);
                     postDataDiscountObject = resposne;
                    }
                }
                else if (itemTiers.discount_type == 'fixed') {
                  if (compare_at_price) {
                     let discounted_price = item_original_price - (item.original_price / 100)
                     function_tierPrice = parseFloat(tierPrice) - discounted_price 
                     function_tierPrice = function_tierPrice < 0 ? 0 :  function_tierPrice
                  }else{
                    function_tierPrice = tierPrice
                  }
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(item_original_price) - parseFloat(tierPrice));
                    if (!isFound) {
                        postDataDiscountObject = createAmountOffDiscountObject(discountMsg, Vid, function_tierPrice, qtys);
                        tempTierProductsobj = { Discountvalue: postDataDiscountObject.value.fixedAmount.amount, DiscountType: 'fixed',VarientID: Vid};
                    }
                }
                else if (itemTiers.discount_type == 'fixed_price') {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(parseFloat(tierPrice));
                    if (!isFound) {
                        tempTierProductsobj = { Discountvalue: tierPrice, DiscountType: 'fixed_price', VarientID: Vid };
                        postDataDiscountObject = createDiscountedPriceDiscountObject(discountMsg, Vid, tierPrice, qtys, item.original_price/100);
                    }
                }
    
                updatedItemPrice = Math.max(0, updatedItemPrice);
    
                if (updatedItemPrice <=  item.original_price/100) {
                    updatedLinePrice = updatedItemPrice * item.quantity;
                    updatedTotalPrice += updatedLinePrice;
                   if (!isFound && postDataDiscountObject) {
                    postDataDiscountArrayObject.push(postDataDiscountObject);
                    TierProducts.push(tempTierProductsobj);
                }
                    UpdateCartItem(item, updatedItemPrice, updatedLinePrice, isNotInRange, isUpdate, index);
                }
                
                    if (updatedItemPrice <  item.original_price/100) {
                   if (!isFound && postDataDiscountObject) {
                    postDataDiscountArrayObject.push(postDataDiscountObject);
                    TierProducts.push(tempTierProductsobj);
                }
                }else{
                       updatedLinePrice = item.original_price / 100 * item.quantity;
                        updatedTotalPrice += updatedLinePrice;
                       UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), isNotInRange, isUpdate, index);
                      //isNotInRange = true
                }
               
            }
        }
        if (isNotInRange) {
            UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), isNotInRange, isUpdate, index);
        }
        return [updatedTotalPrice, isNotInRange];
    }

    var DiscountCodeCookie = function (discount_code) {
        jQuery.ajax({
            type: "HEAD", url: "/discount/" + discount_code,
            success: function (_result) { },
            error: function (e) { console.log(e.statusText); }
        })
    }

    var FetchCartTiers = function () {
        jQuery.ajax({
            async: false,
            url: "/cart/?view=ac_cart_tiers",
            success: function (result) {
                globalFieldsCartPage_AC.cartTiersArray = JSON.parse(result);
                TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
                // Watch for the `.cart-sidebar-show` class
              if (!globalFields.isCartPage) {
                    monitorClass('.cart-sidebar-show', () => {
                 clearFunction();
                });
              }

                   setTimeout(function () {
               TieredPricingCart(globalFieldsCartPage_AC.cartObj, true); CheckoutClickCart(); CheckoutClickAjax();
            }, 800);
            
            },
            error: function (e) { console.log(e.statusText); }
        });
    }
    /*
        var open = window.XMLHttpRequest.prototype.open, send = window.XMLHttpRequest.prototype.send, onReadyStateChange;
        function openReplacement(method, url, async, user, password) { return open.apply(this, arguments); }
        function sendReplacement(data) {
            this.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    ProcessCartResponse(this._url, this.responseText);
                }
            };
            return send.apply(this, arguments);
        }
        window.XMLHttpRequest.prototype.open = openReplacement; window.XMLHttpRequest.prototype.send = sendReplacement;
    */
    jQuery(document).ajaxComplete(function (event, xhr, settings) {
        ProcessCartResponse(settings.url, xhr.responseText);
    });

    var ProcessCartResponse = function (splittedUrl, responseText) {
        if (splittedUrl != 'undefined' && splittedUrl != "" && splittedUrl != null) {
            splittedUrl = splittedUrl.split("?");
            if (splittedUrl[0] == "/cart.js" || splittedUrl[0] == "/cart/change.js") {
                globalFieldsCartPage_AC.cartObj = JSON.parse(responseText);
                setTimeout(function () {
                    FetchCartTiers();
                }, 1000);
            }
        }
    }

    try{
        var nativeFetch = window.fetch;
        window.fetch = function(...args) {
          if(args[0].includes("/cart/change") || args[0].includes("/cart/add")){
            setTimeout(function () {
              fetch('/cart.js')
              .then(r =>  r.json().then(data => ({status: r.status, body: data})))
              .then(obj => ProcessCartResponse("/cart.js", JSON.stringify(obj.body)));
            }, 1000);
          }
          return nativeFetch.apply(window, args);
        }
      }
      catch(e){}

function monitorClass(className, callback, intervalTime = 500) {
    const intervalId = setInterval(() => {
        if ($(className).length) {
            clearInterval(intervalId); // Stop the interval
            callback(); // Execute the callback
        }
    }, intervalTime);
}
// Watch for the `.cart-sidebar-show` class
monitorClass('.cart-sidebar-show', () => {
    console.log('Class found. Executing clear function.');
    clearFunction();
});

// Example clear function
function clearFunction() {
      setTimeout(function () {
               TieredPricingCart(globalFieldsCartPage_AC.cartObj, true); CheckoutClickCart(); CheckoutClickAjax();
            }, 800);
}


  
  
    var SetCookie = function (cname, cvalue, exdays) { var d = new Date(); d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000)); var expires = "expires=" + d.toUTCString(); document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"; }

    TieredPricingCart(globalFieldsCartPage_AC.cartObj, true); CheckoutClickCart(); CheckoutClickAjax();
    $( window ).on( "load", function() {
    setTimeout(function () {
               TieredPricingCart(globalFieldsCartPage_AC.cartObj, true); CheckoutClickCart(); CheckoutClickAjax();
            }, 1000);
    } );
  }

var globalFieldsCartPage_AC = new ACDiscountApp.CartPage.Global(); var cartObject = new ACDiscountApp.CartPage.Show_CalculateTier();